import ResourceService from './resource.service'

class SubCategoryService extends ResourceService {
  static get resource() {
    return 'subcategory'
  }
}

export default SubCategoryService
